import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

// All endpoints require superadmin (server returns 403 otherwise).
const BASE = 'api/lms/ai-provider-configs/';

const actions = {
  // §1.3.1 — list (paginated, but in practice exactly 2 rows).
  async getAiProviderConfigs(_obj, params) {
    const res = await axios.get(BASE, { params });
    return res.data;
  },

  // §1.3.2 — retrieve one.
  async getAiProviderConfig(_obj, id) {
    const res = await axios.get(`${BASE}${id}/`);
    return res.data;
  },

  // §1.3.3 — quick "what's the current grader?" lookup.
  // Resolves to null on 204 No Content (no active row).
  async getActiveAiProviderConfig() {
    const res = await axios.get(`${BASE}active/`, { validateStatus: s => s === 200 || s === 204 });
    if (res.status === 204) return null;
    return res.data;
  },

  // §1.3.4 — partial update. Caller MUST omit api_key unless the user typed
  // a new one. An empty string "" is treated by the server as "no change",
  // but we still strip it client-side to keep request bodies clean.
  async updateAiProviderConfig(_obj, { id, data }) {
    const res = await axios.patch(`${BASE}${id}/`, data);
    return res.data;
  },

  // §1.3.5 — activate (atomic deactivate-others + activate-this).
  // Server validates is_enabled and has_api_key; surfaces 400.
  async activateAiProviderConfig(_obj, id) {
    const res = await axios.post(`${BASE}${id}/activate/`, {});
    return res.data;
  },

  // §1.3.6 — deactivate. After this no provider is active.
  async deactivateAiProviderConfig(_obj, id) {
    const res = await axios.post(`${BASE}${id}/deactivate/`, {});
    return res.data;
  },
};

export const aiProviderConfig = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
